import React from 'react';
import Score from './scoresNonCanvas';
import { GetScoreDefn, getScoreText, GetTextColor } from 'utils/Global';
import EAutoScoreType from 'enums/EAutoScoreType';
import EColors from 'enums/EColors';
import { getScoreToolTip } from 'components/plateviewer/plate/utils';

interface Props {
  scoresOfWellDrops: {
    wellDropScoreId: number;
    autoScoreType: EAutoScoreType;
    autoScoreValue: number;
    scoreDetails?: { item: string; value: string }[]; // Added for tooltip
  }[];
  width: number;
  height: number;
}

/*
 * This component is only for AI/Pridiction Based Auto Scores (for now)
 * @param props
 * @returns
 */
const AutoScoreRenderer = (props: Props) => {
  const { scoresOfWellDrops, width, height } = props;
  const getScoresComponents = () => {
    return scoresOfWellDrops.map((wellDropScore, i) => {
      const score = GetScoreDefn().find(
        (score) => score.wellDropScoreId === wellDropScore.wellDropScoreId,
      );

      if (!score) {
        return null;
      }

      const color = `rgb(${score.color})`;
      const scoreText = getScoreText(wellDropScore, score);
      const textColor =
        wellDropScore.autoScoreType === EAutoScoreType.IP
          ? EColors.White
          : GetTextColor(score.color);

      const toolTipText = getScoreToolTip(wellDropScore, score); // Generate tooltip text

      return (
        <Score
          key={`score-${i}`}
          width={width}
          height={height}
          color={color}
          Scores={scoreText}
          textcolor={textColor}
          toolTipText={toolTipText} // Pass tooltip text to Score
        />
      );
    });
  };

  return <>{getScoresComponents()}</>;
};

export default AutoScoreRenderer;
